import React from 'react'
import { connect } from 'react-redux'
import { changeMatchFilter } from '../actions/matches'

function mapStateToProps(state, props) {
    const { filters, isFetching, result, counts } = state.matches
    const filter = filters[props.filterId]
    const filterResult = filter && result[filter.searchKey]
    const count = filter && counts[filter.searchKey]
    const countOnPage = filter && filterResult[filter.page || 0].length
    return {
        filter,
        count,
        countOnPage,
        isFetching,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeFilter: (id, options) => dispatch(changeMatchFilter(id, options)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
